import natura from "./img/natura_siberica.png"
import organic from "./img/organic.png"
import citylink from "./img/cityLink.png"
import familia from "./img/familia.png"
import vseinstrumenti from "./img/vseinstrumenti.png"
import goodSvyaz from "./img/good_svyaz.png"
import ildebote from "./img/ildebote.png"
import kari from "./img/kari.png"
import lentaOnlain from "./img/lenta_onlain.png"
import sokolov from "./img/sokolov.jpg"
import yandexEda from "./img/yandex_eda.png"
import ylibkaRadugi from "./img/ylibka_radugi.png"
import divanru from "./img/divanru.png"
import onetwotrip from "./img/onetwotrip.png"
import irbis from "./img/irbis.png"
import askona from "./img/askona.png"
import flowwow from "./img/flowwow.png"
import lamoda from "./img/lamoda.png"
import svyazON from "./img/svyazON.jpg"
import RU169 from "./img/169RU.png"
import lentaBlue from "./img/lenta.svg"
import mood2 from "./img/2mood.svg"
import restore from "./img/restore.svg"
import kassir from "./img/kassirru.png"
import acoola from "./img/acoola.svg"
import pyatorochkaRed from "./img/pyatorochkaRed.png"
import ozonBlue from "./img/ozon.svg"
import rolf from "./img/rolf.png"
import strahovanie from "./img/strahovanie.png"
import strahovaneZhizni from "./img/strahovanieZhizni.png"
import ostin from "./img/ostin.png"
import xiaomi from "./img/xiaomi_store.jpg"
import samsung from "./img/samsung.jpg"
import kari2 from "./img/kari2.jpg"
import iport from "./img/iport.jpg"
import huawei from "./img/huawei.jpg"
import apteka from "./img/apteka.png"
import aquanet from "./img/aquanet.png"
import sportmaster from "./img/sportmaster.png"
import market from "./img/Market.webp"
import Hoff from "./img/Hoff.webp"
import dns from "./img/dns.png"
import chitaiGorod from "./img/chitaiGorod.webp"
import perekrestok from "./img/perekrestok.png"
import monetka from "./img/monetka.png"
import bahetle from "./img/bahetle.png"

export const partnersMain = [
  {
    id: 31,
    brand: "ВсеИнструменты.ру",
    icon_url: vseinstrumenti,
    urlName: "vseinstrumenti",
  },
  {
    id: 32,
    brand: "SOKOLOV",
    icon_url: sokolov,
    urlName: "sokolov",
  },
  {
    id: 33,
    brand: "natura_siberica",
    icon_url: natura,
    urlName: "natura_siberica",
  },
  {
    id: 34,
    brand: "organic",
    icon_url: organic,
    urlName: "organic",
  },
  {
    id: 35,
    brand: "flowwow",
    icon_url: flowwow,
    urlName: "flowwow",
  },
  {
    id: 36,
    brand: "rolf",
    icon_url: rolf,
    urlName: "rolf",
  },
  {
    id: 37,
    brand: "ЛУКОЙЛ",
    icon_url: "https://api.halvacard.ru/public-api/files/19e32f63-46aa-485f-9eb0-77cdb152b4d5.png",
    urlName: "lukoil",
  },
  {
    id: 7918,
    brand: "familia",
    icon_url: familia,
    urlName: "familia",
  },
  {
    id: 7760,
    brand: "Хорошая Связь",
    icon_url: goodSvyaz,
    urlName: "horoshajasvjaz",
  },
  {
    id: 8619,
    brand: "ИЛЬ ДЕ БОТЭ",
    icon_url: ildebote,
    urlName: "il-de-bote",
  },
  {
    id: 8363,
    brand: "kari",
    icon_url: kari,
    urlName: "kari",
  },
  {
    id: 253,
    brand: "Лента Онлайн",
    icon_url: lentaOnlain,
    urlName: "lenta-onlajn",
  },
  {
    id: 15,
    brand: "Яндекс Еда",
    icon_url: yandexEda,
    urlName: "yandeks-eda",
  },
  {
    id: 1654,
    brand: "Улыбка Радуги",
    icon_url: ylibkaRadugi,
    urlName: "ulybka-radugi",
  },
  {
    id: 7733,
    brand: "Ситилинк",
    icon_url: citylink,
    urlName: "citilink",
  },
  {
    id: 5,
    brand: "Совкомбанк страхование жизни",
    icon_url: strahovaneZhizni,
    urlName: "sovkombanklife",
  },
  {
    id: 1042,
    brand: "Divan.ru",
    icon_url: divanru,
    urlName: "divanru",
  },
  {
    id: 1994,
    brand: "OneTwoTrip",
    icon_url: onetwotrip,
    urlName: "onetwotrip",
  },
  {
    id: 1,
    brand: "Совкомбанк Страхование",
    icon_url: strahovanie,
    urlName: "sovkombankstrahovanie",
  },
]

export const cashback_factory = [
  {
    id: 33,
    brand: "Hoff",
    icon_url: Hoff,
    urlName: "Hoff",
  },
  {
    id: 35,
    brand: "lamoda",
    icon_url: lamoda,
    urlName: "lamoda",
  },
  {
    id: 23,
    brand: "Яндекс. Маркет",
    icon_url: market,
    urlName: "Яндекс. Маркет",
  },
  {
    id: 32,
    brand: "kari",
    icon_url: kari,
    urlName: "kari",
  },
  {
    id: 7733,
    brand: "Ситилинк",
    icon_url: citylink,
    urlName: "citilink",
  },
]

export const samoletik = [
  {
    id: 32,
    brand: "kari",
    icon_url: kari,
    urlName: "kari",
  },
  {
    id: 33,
    brand: "Экономная аптека",
    icon_url: apteka,
    urlName: "apteka",
  },
  {
    id: 34,
    brand: "aquanet",
    icon_url: aquanet,
    urlName: "aquanet",
  },
  {
    id: 35,
    brand: "lamoda",
    icon_url: lamoda,
    urlName: "lamoda",
  },
  {
    id: 36,
    brand: "sportmaster",
    icon_url: sportmaster,
    urlName: "sportmaster",
  },
  {
    id: 37,
    brand: "ВсеИнструменты.ру",
    icon_url: vseinstrumenti,
    urlName: "vseinstrumenti",
  },
  {
    id: 38,
    brand: "SOKOLOV",
    icon_url: sokolov,
    urlName: "sokolov",
  },
  {
    id: 39,
    brand: "natura_siberica",
    icon_url: natura,
    urlName: "natura_siberica",
  },
]

export const stickerPartners = [
  {
    id: 30,
    brand: "ozon-ru",
    icon_url: ozonBlue,
    urlName: "ozon-ru",
  },
  {
    id: 31,
    brand: "pyatorochka",
    icon_url: pyatorochkaRed,
    urlName: "pyatorochka",
  },
  {
    id: 32,
    brand: "lenta",
    icon_url: lentaBlue,
    urlName: "lenta",
  },
  {
    id: 33,
    brand: "2mood",
    icon_url: mood2,
    urlName: "2mood",
  },
  {
    id: 34,
    brand: "divan.ru",
    icon_url: divanru,
    urlName: "divan.ru",
  },
  {
    id: 35,
    brand: "restore",
    icon_url: restore,
    urlName: "restore",
  },
  {
    id: 36,
    brand: "kassir.ru",
    icon_url: kassir,
    urlName: "kassir.ru",
  },
  {
    id: 37,
    brand: "yandex eda",
    icon_url: yandexEda,
    urlName: "yandex eda",
  },
  {
    id: 38,
    brand: "acoola",
    icon_url: acoola,
    urlName: "acoola",
  },
]

export const kiberponedelnik = [
  {
    id: 32,
    brand: "kari",
    icon_url: kari,
    urlName: "kari",
  },
  {
    id: 33,
    brand: "kari KIDS",
    icon_url: "https://api.halvacard.ru/public-api/files/9f577c4c-ed16-4ba3-83d6-53d9c4d7d5a1.png",
    urlName: "kari-kids-16935838",
  },
  {
    id: 34,
    brand: "askona",
    icon_url: askona,
    urlName: "askona",
  },
  {
    id: 35,
    brand: "ostin",
    icon_url: ostin,
    urlName: "ostin",
  },
  {
    id: 7918,
    brand: "familia",
    icon_url: familia,
    urlName: "familia",
  },
  {
    id: 7760,
    brand: "Хорошая Связь",
    icon_url: goodSvyaz,
    urlName: "horoshajasvjaz",
  },
  {
    id: 8619,
    brand: "ИЛЬ ДЕ БОТЭ",
    icon_url: ildebote,
    urlName: "il-de-bote",
  },
  {
    id: 253,
    brand: "Лента Онлайн",
    icon_url: lentaOnlain,
    urlName: "lenta-onlajn",
  },
  {
    id: 15,
    brand: "Яндекс Еда",
    icon_url: yandexEda,
    urlName: "yandeks-eda",
  },
  {
    id: 1654,
    brand: "Улыбка Радуги",
    icon_url: ylibkaRadugi,
    urlName: "ulybka-radugi",
  },
  {
    id: 7733,
    brand: "Ситилинк",
    icon_url: citylink,
    urlName: "citilink",
  },
  {
    id: 1042,
    brand: "Divan.ru",
    icon_url: divanru,
    urlName: "divanru",
  },
  {
    id: 1994,
    brand: "OneTwoTrip",
    icon_url: onetwotrip,
    urlName: "onetwotrip",
  },
]

export const autoPromo = [
  {
    id: 31,
    brand: "rolf",
    icon_url: rolf,
    urlName: "rolf",
  },
  {
    id: 32,
    brand: "kari",
    icon_url: kari,
    urlName: "kari",
  },
  {
    id: 33,
    brand: "kari KIDS",
    icon_url: "https://api.halvacard.ru/public-api/files/9f577c4c-ed16-4ba3-83d6-53d9c4d7d5a1.png",
    urlName: "kari-kids-16935838",
  },
  {
    id: 34,
    brand: "askona",
    icon_url: askona,
    urlName: "askona",
  },
  {
    id: 35,
    brand: "ostin",
    icon_url: ostin,
    urlName: "ostin",
  },
  {
    id: 7918,
    brand: "familia",
    icon_url: familia,
    urlName: "familia",
  },
  {
    id: 7760,
    brand: "Хорошая Связь",
    icon_url: goodSvyaz,
    urlName: "horoshajasvjaz",
  },
  {
    id: 8619,
    brand: "ИЛЬ ДЕ БОТЭ",
    icon_url: ildebote,
    urlName: "il-de-bote",
  },
  {
    id: 253,
    brand: "Лента Онлайн",
    icon_url: lentaOnlain,
    urlName: "lenta-onlajn",
  },
  {
    id: 15,
    brand: "Яндекс Еда",
    icon_url: yandexEda,
    urlName: "yandeks-eda",
  },
  {
    id: 1654,
    brand: "Улыбка Радуги",
    icon_url: ylibkaRadugi,
    urlName: "ulybka-radugi",
  },
  {
    id: 7733,
    brand: "Ситилинк",
    icon_url: citylink,
    urlName: "citilink",
  },
  {
    id: 1042,
    brand: "Divan.ru",
    icon_url: divanru,
    urlName: "divanru",
  },
  {
    id: 1994,
    brand: "OneTwoTrip",
    icon_url: onetwotrip,
    urlName: "onetwotrip",
  },
]

export const newYearPartners = [
  {
    id: 8363,
    brand: "kari",
    icon_url: kari,
    urlName: "kari",
  },
  {
    id: 37,
    brand: "svyazON",
    icon_url: svyazON,
    urlName: "svyazON",
  },
  {
    id: 38,
    brand: "lamoda",
    icon_url: lamoda,
    urlName: "lamoda",
  },
  {
    id: 36,
    brand: "rif_gosh",
    icon_url: "https://api.halvacard.ru/public-api/files/f257db49-1b0b-49c3-96b2-a7ce71f7400f.png",
    urlName: "rif_gosh",
  },
  {
    id: 39,
    brand: "169RU",
    icon_url: RU169,
    urlName: "169RU",
  },
  {
    id: 32,
    brand: "SOKOLOV",
    icon_url: sokolov,
    urlName: "sokolov",
  },
  {
    id: 34,
    brand: "askona",
    icon_url: askona,
    urlName: "askona",
  },
]

export const partnersIrbis = [
  {
    id: 31,
    brand: "irbis",
    icon_url: irbis,
    urlName: "irbis",
  },
  {
    id: 32,
    brand: "SOKOLOV",
    icon_url: sokolov,
    urlName: "sokolov",
  },
  {
    id: 33,
    brand: "natura_siberica",
    icon_url: natura,
    urlName: "natura_siberica",
  },
  {
    id: 34,
    brand: "organic",
    icon_url: organic,
    urlName: "organic",
  },
  {
    id: 35,
    brand: "flowwow",
    icon_url: flowwow,
    urlName: "flowwow",
  },
  {
    id: 36,
    brand: "rolf",
    icon_url: rolf,
    urlName: "rolf",
  },
  {
    id: 37,
    brand: "ЛУКОЙЛ",
    icon_url: "https://api.halvacard.ru/public-api/files/19e32f63-46aa-485f-9eb0-77cdb152b4d5.png",
    urlName: "lukoil",
  },
  {
    id: 38,
    brand: "ВсеИнструменты.ру",
    icon_url: vseinstrumenti,
    urlName: "vseinstrumenti",
  },
  {
    id: 7918,
    brand: "familia",
    icon_url: familia,
    urlName: "familia",
  },
  {
    id: 7760,
    brand: "Хорошая Связь",
    icon_url: goodSvyaz,
    urlName: "horoshajasvjaz",
  },
  {
    id: 8619,
    brand: "ИЛЬ ДЕ БОТЭ",
    icon_url: ildebote,
    urlName: "il-de-bote",
  },
  {
    id: 8363,
    brand: "kari",
    icon_url: kari,
    urlName: "kari",
  },
  {
    id: 253,
    brand: "Лента Онлайн",
    icon_url: lentaOnlain,
    urlName: "lenta-onlajn",
  },
  {
    id: 15,
    brand: "Яндекс Еда",
    icon_url: yandexEda,
    urlName: "yandeks-eda",
  },
  {
    id: 1654,
    brand: "Улыбка Радуги",
    icon_url: ylibkaRadugi,
    urlName: "ulybka-radugi",
  },
  {
    id: 7733,
    brand: "Ситилинк",
    icon_url: citylink,
    urlName: "citilink",
  },
  {
    id: 1042,
    brand: "Divan.ru",
    icon_url: divanru,
    urlName: "divanru",
  },
  {
    id: 1994,
    brand: "OneTwoTrip",
    icon_url: onetwotrip,
    urlName: "onetwotrip",
  },
]

export const partnersMayTrudHalva = [
  {
    id: 31,
    brand: "xiaomi",
    icon_url: xiaomi,
    urlName: "xiaomi",
  },
  {
    id: 32,
    brand: "HUAWEI",
    icon_url: huawei,
    urlName: "huawei",
  },
  {
    id: 33,
    brand: "iPort",
    icon_url: iport,
    urlName: "iPort",
  },
  {
    id: 34,
    brand: "Lamoda",
    icon_url: lamoda,
    urlName: "lamoda",
  },
  {
    id: 35,
    brand: "Samsung",
    icon_url: samsung,
    urlName: "samsung",
  },
  {
    id: 36,
    brand: "Kari",
    icon_url: kari2,
    urlName: "Kari",
  },
]

export const cashback100 = [
  {
    id: 33,
    brand: "Hoff",
    icon_url: Hoff,
    urlName: "Hoff",
  },
  {
    id: 34,
    brand: "Яндекс Маркет",
    icon_url: market,
    urlName: "Яндекс Маркет",
  },
  {
    id: 35,
    brand: "Kari",
    icon_url: kari2,
    urlName: "Kari",
  },
  {
    id: 36,
    brand: "dns",
    icon_url: dns,
    urlName: "dns",
  },
  {
    id: 37,
    brand: "sportmaster",
    icon_url: sportmaster,
    urlName: "sportmaster",
  },
  {
    id: 35,
    brand: "flowwow",
    icon_url: flowwow,
    urlName: "flowwow",
  },
  {
    id: 36,
    brand: "rolf",
    icon_url: rolf,
    urlName: "rolf",
  },
]

export const zhkh = [
  {
    id: 31,
    brand: "pyatorochka",
    icon_url: pyatorochkaRed,
    urlName: "pyatorochka",
  },
  {
    id: 32,
    brand: "Перекресток",
    icon_url: perekrestok,
    urlName: "Перекресток",
  },
  {
    id: 33,
    brand: "Бахетле",
    icon_url: bahetle,
    urlName: "Бахетле",
  },
  {
    id: 34,
    brand: "lenta",
    icon_url: lentaBlue,
    urlName: "lenta",
  },
  {
    id: 35,
    brand: "Монетка",
    icon_url: monetka,
    urlName: "Монетка",
  },
  {
    id: 36,
    brand: "flowwow",
    icon_url: flowwow,
    urlName: "flowwow",
  },
  {
    id: 37,
    brand: "rolf",
    icon_url: rolf,
    urlName: "rolf",
  },
]

export const btsMedia = [
  {
    id: 33,
    brand: "kari",
    icon_url: kari2,
    urlName: "Kari",
  },
  {
    id: 34,
    brand: "askona",
    icon_url: askona,
    urlName: "askona",
  },
  {
    id: 35,
    brand: "ChitaiGorod",
    icon_url: chitaiGorod,
    urlName: "ChitaiGorod",
  },
  {
    id: 36,
    brand: "Ситилинк",
    icon_url: citylink,
    urlName: "citilink",
  },
  {
    id: 37,
    brand: "pyatorochka",
    icon_url: pyatorochkaRed,
    urlName: "pyatorochka",
  },
]

export const smartWeeks = [
  {
    id: 32,
    brand: "kari",
    icon_url: kari,
    urlName: "kari",
  },
  {
    id: 33,
    brand: "kari KIDS",
    icon_url: "https://api.halvacard.ru/public-api/files/9f577c4c-ed16-4ba3-83d6-53d9c4d7d5a1.png",
    urlName: "kari-kids-16935838",
  },
  {
    id: 34,
    brand: "askona",
    icon_url: askona,
    urlName: "askona",
  },
  {
    id: 35,
    brand: "ostin",
    icon_url: ostin,
    urlName: "ostin",
  },
  {
    id: 7918,
    brand: "familia",
    icon_url: familia,
    urlName: "familia",
  },
  {
    id: 31,
    brand: "rolf",
    icon_url: rolf,
    urlName: "rolf",
  },
  {
    id: 7760,
    brand: "Хорошая Связь",
    icon_url: goodSvyaz,
    urlName: "horoshajasvjaz",
  },
  {
    id: 8619,
    brand: "ИЛЬ ДЕ БОТЭ",
    icon_url: ildebote,
    urlName: "il-de-bote",
  },
  {
    id: 253,
    brand: "Лента Онлайн",
    icon_url: lentaOnlain,
    urlName: "lenta-onlajn",
  },
  {
    id: 15,
    brand: "Яндекс Еда",
    icon_url: yandexEda,
    urlName: "yandeks-eda",
  },
  {
    id: 1654,
    brand: "Улыбка Радуги",
    icon_url: ylibkaRadugi,
    urlName: "ulybka-radugi",
  },
  {
    id: 7733,
    brand: "Ситилинк",
    icon_url: citylink,
    urlName: "citilink",
  },
  {
    id: 1042,
    brand: "Divan.ru",
    icon_url: divanru,
    urlName: "divanru",
  },
  {
    id: 1994,
    brand: "OneTwoTrip",
    icon_url: onetwotrip,
    urlName: "onetwotrip",
  },
]
